export const CREATOR_AUTHORITY_PROJECTION_SCHEMA =
  'agent_creator_application_authority_projection_v1';

export const creatorAuthorityDisplayState = (
  agent = {},
  source = 'agent_display',
) => {
  const projection = agent?.creator_authority_projection || {};
  const validProjection =
    projection?.schema === CREATOR_AUTHORITY_PROJECTION_SCHEMA;
  const creatorMarkerPresent = Boolean(
    agent?.schema === 'agent_creator_saved_agent_v1' ||
      agent?.rebuilt_creator_artifact ||
      agent?.creator_authority_projection ||
      agent?.creator_control_state ||
      agent?.creator_persistence_permit ||
      agent?.creator_quality_report ||
      agent?.blocking_repair_ledger ||
      agent?.final_authority_state ||
      agent?.persistence_permit ||
      agent?.created_by_agent_creator ||
      agent?.agent_creator ||
      agent?.final_gate?.creator_control_state_schema ===
        'creator_control_state_v1' ||
      agent?.final_gate?.agent_creator_final_save_contract_refresh,
  );
  const creatorLikeAgent = Boolean(
    (validProjection && projection?.creator_like === true) ||
      (creatorMarkerPresent && !validProjection),
  );
  const missingOrInvalidProjection = Boolean(
    creatorMarkerPresent && !validProjection,
  );
  const blocker =
    (missingOrInvalidProjection ? 'missing_or_invalid_projection' : '') ||
    (creatorLikeAgent && projection?.callable !== true
      ? projection?.reason
      : '') ||
    agent?.saved_agent_contract_deployment_blocker ||
    agent?.chunk2_saved_agent_deployment_blocker_state
      ?.concrete_current_blocker ||
    agent?.chunk2_saved_agent_can_call_gate_state
      ?.concrete_current_blocker ||
    '';
  const centralCanCall = Boolean(
    creatorLikeAgent &&
      projection?.clean === true &&
      projection?.deployable === true &&
      projection?.callable === true,
  );
  const legacyCanCall = Boolean(
    !creatorMarkerPresent &&
      agent?.callable !== false &&
      agent?.status !== 'draft' &&
      !blocker,
  );
  const canCall = centralCanCall || legacyCanCall;

  return {
    source,
    creator_like_agent: creatorLikeAgent,
    creator_origin_marker_present: creatorMarkerPresent,
    authority_kind: validProjection
      ? projection?.authority_kind
      : creatorMarkerPresent
        ? 'creator_origin_metadata'
        : null,
    active_blocker: !canCall,
    can_call: canCall,
    clean: centralCanCall,
    deployable: centralCanCall,
    review_required: creatorLikeAgent
      ? projection?.review_required !== false
      : !canCall,
    deployment_status: agent?.deployment_status || '',
    concrete_current_blocker: blocker || null,
  };
};
